<template>

  <el-col
    class="content"
    :xl="{ span: 18 }"
    :lg="{ span: 18 }"
    :md="{ span: 18 }"
    :xs="{ span: 24 }"
    :sm="{ span: 24 }"
  >
    <div class="mydoc">
      <div class="header" style="font-weight: 900">
        【实验语言学】实验软件
      </div>
      <div class="mybody">
        <p>
          (1) “桌上语音工作室” (Mini-Speech-Lab)
          这是由南开大学朱思俞教授和石锋教授合作研发。适合广大文科背景的语言研究者使用。它具有一般语图仪所具有的语音录放和分析的各种功能，并且可以自动或半自动进行声调格局、元音格局、辅音格局分析的数据测算和统计作图。
          联系方式 zhusy711@126.com
        </p>
        <div style="display: flex; align-items: center; margin-left: 40px">
          <h4 style="cursor: pointer; color: cornflowerblue; width: fit-content; margin-right: 20px" @click="downloadFile">下载文件</h4>
          <h4 style="width: fit-content; color: cornflowerblue">下载次数：{{DownloadCount}}</h4>
        </div>
        <p>
          (2)praat软件 praat软件由荷兰学者Paul Boersma和David
          Weenink开发，具有免费、开源、跨平台运行、功能众多的特点。它可在Windows、Macintosh、Linux等操作系统上运行，具有语音录制、语音编辑、语音分析、语音合成、语音听辨、语音标注、数值统计、文本处理、图片绘制等诸多功能，是语音学界教学与研究的重要工具。
        </p>
        <p>
          (3)Cool edit Pro （Adobe Audition 的前身）软件
          由Syntrillium软件公司开发的多轨录音和音频处理软件，2003年由Adobe公司收购并推出更名版本Adobe
          Audition。Audition是一个功能强大的数字音频工作站，可以通过多音轨、声波或频谱等界面实现音频文件的创建和各类编辑工作，包括高质量录音、声音合成，增加音频效果（噪声调节、压缩扩展、回声、延迟）以及对声音文件进行剪辑、复制、合并、重叠、修复等，该软件还可以支持多文件操作，实现自动静音检测和删除、自动节拍查找等，并能在多种音频文件格式间进行转换。
        </p>
        <p>
          (4)E-prime软件
          这是由卡内基梅隆大学、匹兹堡大学和美国PST公司联合开发的一套用于计算机化行为研究的心理学实验操作平台。相对于传统的编程语言，E-prime可以组合模块化工具包构建清晰的实验流程，进行实验操作和数据收集。其呈现的刺激文件可以是文本、图像、声音以及动态影像等，并提供详细的时间信息细节，包括刺激呈现时间、被试反应时间等，精度可达毫秒。语音学研究中，语音范畴感知的实验范式也经常要通过使用E-prime软件来实现。(5)MATLAB软件
          这是是美国MathWorks公司出品的商业数学软件，广泛用于数据分析、无线通信、深度学习、图像处理与计算机视觉、信号处理、量化金融与风险管理、机器人，控制系统等领域。MATLAB主要面对科学计算、可视化以及交互式程序设计的高科技计算环境，将数值分析、矩阵计算、科学数据可视化以及非线性动态系统的建模和仿真等诸多强大功能集成在一个易于使用的视窗环境中，在很大程度上摆脱了传统非交互式程序设计语言（如C、Fortran）的编辑模式。
        </p>
      </div>
    </div>
  </el-col>
</template>>

<script>
import loginComponent from '@/components/loginComponent'
import {getDownloadCount} from '@/api/data'

export default {
  name: "software",
  components: {
    loginComponent
  },
  data() {
    return {
      DownloadCount: ''
    }
  },
  mounted() {
    this.getDownloadCount()
  },
  methods: {
    downloadFile() {
      window.open('http://www.exp-linguistics.com/manuscript/file/download')
    },
    getDownloadCount() {
      getDownloadCount().then(res => {
        console.log(res, '下载次数获取')
        this.DownloadCount = res.data.result
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.el-row {
  //   background-color: white;
  margin: auto;
}

.introduction_pre {
  width: auto;
  margin: 10px 5px 10px 5px; /**边框距离 上右边下左 */
  background-color: white;
  overflow: hidden;
}

.introduction {
  border: 1px solid #b3c0d1;
  height: 920px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* margin-top: 5px; */
}

.about {
  min-height: calc(100vh - 8rem);
}

.showappbox {
  display: flex;

  .left {
    text-align: left;
  }
}

.content {
  margin-top: 12px;

  .mylink {
    height: 18rem;
    border-radius: 4px;
    background: rgba($color: #ffffff, $alpha: 0.5);
    box-shadow: 2px 3px 10px rgb(51, 72, 94);

    .mybody {
      //   padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .body-item {
        cursor: pointer;
      }

      .num {
        font-size: 55px;
        font-weight: bold;
      }
    }
  }

  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;

    .mybody {
      //   background: linear-gradient(45deg, #34495e, #41b883);
      height: 940px;
      padding: 10px;
      background-color: white;
      overflow: auto;
    }

    p {
      color: black;
      text-indent: 30px;
      line-height: 24px;
      padding: 10px;
    }
  }
}

.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}
</style>



// WEBPACK FOOTER //
// src/view/software.vue